<template>
    <!-- 营销管理－推荐码管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'recommendIndex')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="vip-form">
                <a-form-item label="推荐人名称">
                    <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search"></a-input>
                </a-form-item>
                <a-form-item label="推荐人手机号">
                    <a-input placeholder="请输入" v-decorator="['phone']"></a-input>
                </a-form-item>
                <a-form-item label="推荐号">
                    <a-input placeholder="请输入" v-decorator="['recommendCode']"></a-input>
                </a-form-item>
                <a-form-item label="状态">
                    <a-select allowClear placeholder="请选择" v-decorator="['isEnable']">
                        <a-select-option :value="0">已冻结</a-select-option>
                        <a-select-option :value="1">使用中</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
                </a-form>
            </div>
            <a-card v-if="shopId != -1">
                <div slot="extra">
                    <a-button type="primary" @click="toStaff">员工业绩统计</a-button>
                    <a-button v-if="getBtnByAuth('addRecommend')" type="primary" @click="openModal">新建推荐码</a-button>
                    <a-button v-if="getBtnByAuth('downloadRecommend')" @click="batchDownload">打包下载全部推荐码</a-button>
                </div>
                <a-table :scroll="{y: 560}" bordered :dataSource="dataSource" @change="changePage" :columns="columns" :pagination="pagination" :rowKey="record => record.id">
                    <span slot="isEnable" slot-scope="text">{{['已冻结','使用中'][Number(text)]}}</span>
                    <span slot="empty" slot-scope="empty">{{empty || '--'}}</span>
                    <span slot="action" slot-scope="a,row">
                        <a-popconfirm
                            v-if="getBtnByAuth('disabledRecommend')"
                            :title="'是否确认'+(row.isEnable?'冻结？':'解冻？')"
                            @confirm="confirm(row.id, row.isEnable)"
                            >
                            <a class="text-primary">{{row.isEnable ? '冻结' : '解冻'}}</a>
                            <a-divider type="vertical"/>
                        </a-popconfirm>
                        <span v-if="getBtnByAuth('detailRecommend')">
                            <a class="text-primary" @click="openModalDeposits(row.qrUrl)">推荐码查看</a>
                        </span>
                    </span>
                </a-table>
            </a-card>
			<a-empty class="pt24 pb24" v-else >
				<span slot="description" class="font-big22">请切换到各门店查看</span>
			</a-empty>
            <a-modal
                :visible="visible"
                centered
                title='新建推荐人'
                @cancel="visible = false; formModel.resetFields();"
                @ok="handleCreate"
                :confirmLoading="confirmLoading"
                >
                <a-form :form="formModel">
                    <a-form-item label="推荐人名称" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                        <a-input placeholder="请输入" v-decorator="['name',{rules: [{required: true, message: '请输入推荐人名称'}]}]"></a-input>
                    </a-form-item>
                    <a-form-item label="推荐人手机号" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                        <a-input placeholder="请输入" v-decorator="['phone',{rules: [{required: true, message: '请输入推荐人手机号'}]}]"></a-input>
                    </a-form-item>
                </a-form>
            </a-modal>
            <a-modal :visible="showQrurl" centered title="推荐码查看" okText="下载" @cancel="showQrurl = false" @ok="downloadEr">
                <img :src="qrUrl" alt="">
            </a-modal>
            <report-export-modal ref="reportExportModal" :exportType="22"></report-export-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";

    export default {
    name: "recommender",
    components: {},
    props: {},
    data() {
        const columns = [
        {
            title: "推荐人",
            dataIndex: "name"
        },
        {
            title: "推荐人手机号",
            dataIndex: "phone"
        },
        {
            title: "门店",
            dataIndex: "shopName"
        },
        {
            title: "推荐号",
            dataIndex: "recommendCode"
        },
        {
            title: "状态",
            dataIndex: "isEnable",
            scopedSlots: { customRender: "isEnable" }
        },
        {
            title: "冻结时间",
            dataIndex: "disableTime",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" }
        }];
        return {
            labelCol: {span: 6},
            wrapperCol: {span: 15},
            columns,
            confirmLoading: false,
            visible: false,
            showQrurl: false,
            dataSource: [],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            },
            qrUrl: undefined,
        };
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    methods: {
        // 分页change
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getList()
        },
        // 搜索条件重置
        handleReset () {
            this.form.resetFields();
            this.dataSource = [];
            this.getList()
        },
        search() {
            this.pagination.current = 1;
            this.getList();
        },
        // 获取列表
        getList() {
            this.form.validateFields((err, values) => {
                if(err) return;
                this.$api.operation.recommendList({
                    body: {
                        ...values,
                        shopId: this.shopId,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize
                    }
                }).then(res => {
                    this.pagination.total = res.total;
                    this.dataSource = res.list;
                });
            });
        },
        confirm(id, isEnable) {
            if(isEnable) {
                this.$api.operation.disabledRecommend({
                    params: {
                        id: id
                    }
                }).then(res => {
                    this.$message.success('操作成功');
                    this.getList()
                });
            }else {
                this.$api.operation.enabledRecommend({
                    query: {
                        id: id
                    }
                }).then(res => {
                    this.$message.success('操作成功');
                    this.getList()
                });
            }
        },
        // 打开弹框
        openModalDeposits(qrUrl) {
            this.showQrurl = true;
            this.qrUrl = qrUrl;
        },
        // 打开弹框
        openModal() {
            this.visible = true
        },
        toStaff() {
            this.$router.push({name: 'recommendStatistics'})
        },
        handleCreate() {
            this.formModel.validateFields((err, values) => {
                if(err) return;
                this.confirmLoading = true;
                values.phone = values.phone.trim();
                this.$api.operation.addRecommend({
                    body: {
                        ...values,
                        shopId: this.shopId,
                        shopName: sessionStorage.getItem('currentShopName')
                    }
                }).then(res => {
                    this.visible = false;
                    this.confirmLoading = false;
                    this.$message.success('操作成功');
                    this.formModel.resetFields();
                    this.getList()
                }).catch(err => {
                    this.confirmLoading = false;
                })
            });
        },
        // 下载二维码
        downloadEr() {//下载图片地址和图片名
            this.$api.common.downloadImage({
                query: {
                    url: this.qrUrl
                }
            }, {
                responseType: 'blob'
            }).then(res => {
                let a = document.createElement("a");
                let event = new MouseEvent("click"); // 创建一个单击事件
                let blob = new Blob([res.data], {
                    type: "image/png"
                });
                let name = this.qrUrl.split('/')[this.qrUrl.split('/').length-1]
                this.downloadUrl = window.URL.createObjectURL(blob);
                a.setAttribute("href", this.downloadUrl);
                a.setAttribute("download", `${name}.png`);
                a.dispatchEvent(event); // 触发a的单击事件
            });
        },
        /**
         * @func openExportModal 打开导出记录弹窗
         */
        openExportModal() {
            this.$refs.reportExportModal.open();
        },
        batchDownload() {//下载图片地址和图片名
            this.form.validateFields((err, values) => {
                if(err) return;
                this.$api.operation.recommendExport({
                    body: {
                        ...values,
                        shopId: sessionStorage.getItem('currentShopId')
                    }
                })
                .then(res => {
                    this.openExportModal();
                });
            });
        },
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
        this.formModel = this.$form.createForm(this);
    },
    created() {},
    mounted() {
        this.getList();
    },
    watch: {
        shopId(val) {
            this.search()
        }
    }
};
</script>
<style lang="scss">
</style>
